import React, {FunctionComponent} from 'react';
import {useTranslation} from "react-i18next";
import {Autocomplete, createFilterOptions} from "@mui/material";
import TextField from "@mui/material/TextField";

export interface FilterableCategory {
    inputValue: string;
    value: string;
}

export const CategoryAutocomplete: FunctionComponent<CategoryAutocompleteProps> = props => {
    const {t} = useTranslation();
    const filter = createFilterOptions<FilterableCategory>();

    return <Autocomplete
        fullWidth={props.fullWidth}
        className={props.className}
        value={props.value}
        onChange={(event, newValue) => {
            if (typeof newValue === 'string') {
                props.setValue({
                    value: newValue
                } as FilterableCategory);
            } else if (newValue && newValue.inputValue) {
                props.setValue({
                    ...newValue,
                    value: newValue.inputValue
                } as FilterableCategory);
            } else {
                props.setValue(newValue as FilterableCategory);
            }
        }}
        filterOptions={(options, params) => {
            const filtered = filter(options, params);

            if (params.inputValue !== '') {
                filtered.push({
                    inputValue: params.inputValue,
                    value: t("categoryAutocompleteAdd", {inputValue: params.inputValue}),
                } as FilterableCategory);
            }

            return filtered;
        }}
        selectOnFocus
        clearOnBlur
        noOptionsText={t("No option")}
        handleHomeEndKeys
        options={props.options}
        getOptionLabel={(option) => {
            if (typeof option === 'string') {
                return option;
            }

            if (option.inputValue) {
                return option.inputValue;
            }

            return option.value;
        }}
        freeSolo
        renderInput={(params) => (
            <TextField {...params} label={props.label} variant="outlined"/>
        )}
    />;
}

export interface CategoryAutocompleteProps {
    value: FilterableCategory;
    options: FilterableCategory[];
    setValue: (value: FilterableCategory) => void;
    label: string;
    className?: string;
    fullWidth?: boolean
}